import { Box, Button, Text, Image, Placeholder } from "@suit-ui/react";
import Layout from "./Layout";
import { useTranslation } from "react-i18next";
import { useGetApps } from "../useCases/useGetApps";
import { useNavigate } from "react-router-dom";
import { useGetAppUrl } from "../useCases/useGetAppUrl";
import { getAppLogo } from "../utils/tenant";

export function TenantApps() {
  const { t } = useTranslation();
  const { data: userApps, isPending: isUserAppLoadPending } = useGetApps();
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useGetAppUrl();
  const handleLogout = () => navigate("/logout", { replace: true });

  if (!isUserAppLoadPending && userApps?.length === 0) {
    return (
      <Layout className="p-11">
        <Placeholder variant="vertical">
          <Placeholder.Image>
            <Placeholder.EmptyIcon />
          </Placeholder.Image>
          <Placeholder.Content>
            <Placeholder.Title>
              {t("login_page.tenant_apps_empty_title")}
            </Placeholder.Title>
            <Placeholder.Description>
              {t("login_page.tenant_apps_empty_description")}
            </Placeholder.Description>
          </Placeholder.Content>
          <Placeholder.BtnGroup>
            <Button className="ml-auto flex mt-4" onClick={handleLogout}>
              {t("ui.logout_button")}
            </Button>
          </Placeholder.BtnGroup>
        </Placeholder>
      </Layout>
    );
  }

  return (
    <Layout className="p-11">
      <Text className="text-lg text-neutral-600 font-bold">
        {t("login_page.tenant_apps_title")}
      </Text>
      <Box className="mt-7">
        {userApps?.map((app) => (
          <Button
            disabled={isPending}
            key={app._id}
            size="lg"
            variant="text"
            className="w-full h-24 my-3 rounded-lg shadow-md"
            onClick={async () => {
              // Redirect to the app URL with the SSO token included.
              const { app_url } = await mutateAsync(app.code);
              const url = new URL(app_url);
              window.location.href = url.toString();
            }}
          >
            <Image
              src={getAppLogo(app.code)}
              alt={app.name}
              className="w-[250px]"
            />
          </Button>
        ))}
      </Box>

      <Button className="ml-auto flex mt-4" onClick={handleLogout}>
        {t("ui.logout_button")}
      </Button>
    </Layout>
  );
}
